import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CollaborationContainer = styled(Box)`
  margin: 42px auto 48px auto;
  padding: 0px 24px;
  max-width: 1136px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-top: 78px;
    margin-bottom: 68px;
    flex-direction: column;
    align-items: center;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin-top: 106px;
    margin-bottom: 95px;
    flex-direction: row;
    gap: 127px;
  }
`;

export const VideoContainer = styled('video')`
  margin-top: 12px;
  width: 100%;
  max-width: calc(100% - 48px);
  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: calc(100% - 500px);
    height: 49%;
  }
`;
